import "core-js/modules/es.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "cpt-dataV-border",
  props: {
    width: Number,
    height: Number,
    option: Object
  },
  data: function data() {
    return {};
  }
};